import React, { useEffect } from 'react';
import { PeekMenuItem, PeekListItemText, PeekListItemIcon, PeekTypography, PeekCollapse, PeekMenuList } from '@piiqtechnologies/ui-components';
import { ChevronUp, ChevronDown } from '@piiqtechnologies/svg-icons';

const ViewerNavMenuItem = ({ allowRootSelect, onClick, items, selectedItemId, name, itemId, disablePadding, onExpandChange, expanded, }) => {
    const isExpandable = items && items.length > 0;
    const selected = selectedItemId === itemId || (isExpandable && items.some((item) => item.itemId === selectedItemId));
    useEffect(() => {
        if (isExpandable && onExpandChange && selected && !expanded) {
            onExpandChange(true);
        }
    }, [selected]);
    const handleExpandClick = (event) => {
        onExpandChange && onExpandChange(!expanded);
        event.stopPropagation();
    };
    const onViewerNavMenuItemClick = () => {
        onClick(itemId);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekMenuItem, { hoverBgColor: "info", selectedBgColor: "info", onClick: (isExpandable && !allowRootSelect && handleExpandClick) || onViewerNavMenuItemClick, sx: { pl: (!disablePadding && 1.5) || 0, pr: 0, py: 1.15, minHeight: 41 } },
            React.createElement(PeekListItemText, { primary: name, primaryTypographyProps: {
                    color: (selected && (!isExpandable || allowRootSelect) && "secondary") || "primary",
                    variant: "body1",
                    fontWeight: ((selected || isExpandable) && "fontWeightBold") || "fontWeightRegular",
                } }),
            isExpandable && (React.createElement(PeekListItemIcon, null,
                React.createElement(PeekTypography, { lineHeight: 0, color: (selected && "secondary") || "primary" }, (expanded && React.createElement(ChevronUp, { height: 18, width: 20 })) || React.createElement(ChevronDown, { height: 18, width: 20 }))))),
        isExpandable && (React.createElement(PeekCollapse, { in: expanded, timeout: "auto", unmountOnExit: true },
            React.createElement(PeekMenuList, { disablePadding: true, sx: { px: 1.5 } }, items.map((item, index) => (React.createElement(ViewerNavMenuItem, Object.assign({}, item, { selectedItemId: selectedItemId, onClick: onClick, key: index })))))))));
};

export { ViewerNavMenuItem, ViewerNavMenuItem as default };
